import lazysizes from 'lazysizes'
import 'lazysizes/plugins/parent-fit/ls.parent-fit'
import register from 'preact-custom-element'
import 'lite-youtube-embed/src/lite-yt-embed'

import 'libs/accessibility'
import 'libs/link'
import 'modules/carousel-swiper/carousel-swiper-custom'
import 'snippets/modal-dialog/modal-dialog'
import NoticeGlobal from 'snippets/notice-global/notice-global'
import 'snippets/slideout/slideout'

import 'modules/video-player/video-player'
import 'snippets/accordion-list/accordion-list'

import 'styles/theme.css'

register(NoticeGlobal, 'notice-global')

lazysizes.init()
